const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// 카드 공개 조회 (비로그인 가능, 로그인 시 isOwner 포함)
export async function getCard(shortId, idToken = null) {
  const headers = {};
  if (idToken) headers['Authorization'] = `Bearer ${idToken}`;
  try {
    const res = await fetch(`${API_BASE}/card/${shortId}`, { headers });
    if (res.status === 404) return null;
    if (!res.ok) return null;
    return res.json(); // { status, shortId, urlParams, ownerId, isOwner, viewCount }
  } catch {
    return null;
  }
}

// 내 카드 목록 조회 (최신순)
export async function getMyCards(idToken) {
  try {
    const res = await fetch(`${API_BASE}/api/my/cards`, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
    if (!res.ok) return [];
    const data = await res.json();
    return data.cards || [];
  } catch {
    return [];
  }
}

// 카드 저장 (새로 생성 or 업데이트)
// details: { name, title, company, email, phone, website, sns, address } - 분석/마이그레이션용
export async function saveCard(urlParams, shortId, idToken, details = null) {
  const res = await fetch(`${API_BASE}/api/card`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ urlParams, shortId: shortId || '', details }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || '카드 저장 실패');
  }
  return res.json(); // { status: 'ok', shortId }
}

// 내 카드 소유권 검증 + 데이터 조회
// 반환: { status: 'ok'|'not_found'|'error', shortId?, urlParams?, updatedAt? }
export async function verifyMyCard(shortId, idToken) {
  try {
    const res = await fetch(`${API_BASE}/api/my/card?shortId=${encodeURIComponent(shortId)}`, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
    if (res.status === 404) return { status: 'not_found' };
    if (!res.ok) return { status: 'error' };
    return res.json();
  } catch {
    return { status: 'error' };
  }
}
